import React, { useEffect, useState } from 'react'
import { Table } from 'antd'
import styles from '../statistics.module.css'
import { useHistory } from 'react-router-dom'
import { IntTextFormatter } from '../../helper/Integer/IntegerFormatter'
import { useIntl } from 'react-intl'
import { useSettings } from '../../helper/context/SettingsContext'

export default function CategoryTransactionTable ({
  dataSet,
  loading,
  managerId,
  date
}) {
  const lang = useIntl()
  const [data, setData] = useState({
    items: [],
    balance: { currency: '', currency_text: '' }
  })

  const history = useHistory()
  const [columns, setColumns] = useState([])
  const { returnEnabled } = useSettings()

  const parseData = () => {
    const {
      balance,
      chartData: { items }
    } = dataSet

    const { graphItems } = items.reduce(
      (data, el) => {
        const dataItem = {
          category: el.category,
          profit: el.profit,
          transaction: el.transaction,
          profitPercentage: el.profitPercentage,
          expense: el.expense ? el.expense : 0
        }
        if (returnEnabled) {
          data.graphItems.push({
            ...dataItem,
            returnTransaction: el.returnTransaction
          })
        } else {
          data.graphItems.push(dataItem)
        }
        return data
      },
      { graphItems: [] }
    )
    setData({ ...data, items: graphItems, balance: balance })
    setupTableColumns(balance.currency_text)
  }

  const setupTableColumns = currency => {
    const columns = [
      {
        title: lang.formatMessage({ id: 'category' }),
        dataIndex: 'category',
        render: category => category.name,
        sorter: (a, b) => a.category.name.localeCompare(b.category.name),
        sortDirections: ['descend', 'ascend']
      },
      {
        title: lang.formatMessage({ id: 'transaction' }),
        dataIndex: 'transaction',
        render: transaction => (
          <IntTextFormatter currencyText={currency} number={transaction} />
        ),
        sorter: (a, b) => a.transaction - b.transaction,
        sortDirections: ['descend', 'ascend']
      },
      {
        title: lang.formatMessage({ id: 'profit' }),
        dataIndex: 'profit',
        render: profit => (
          <IntTextFormatter currencyText={currency} number={profit} />
        ),
        sorter: (a, b) => a.profit - b.profit,
        sortDirections: ['descend', 'ascend']
      },
      {
        title: lang.formatMessage({ id: 'profit_percentage' }),
        dataIndex: 'profitPercentage',
        render: profitPercentage =>
          `${profitPercentage ? profitPercentage + '%' : '-'}`,
        sorter: (a, b) => {
          if (!a.profitPercentage) {
            return -1
          } else if (!b.profitPercentage) {
            return 1
          }
          return a.profitPercentage - b.profitPercentage
        },
        sortDirections: ['descend', 'ascend']
      }
    ]
    if (returnEnabled) {
      columns.push({
        title: lang.formatMessage({ id: 'return_transaction' }),
        dataIndex: 'returnTransaction',
        render: returnTransaction => (
          <IntTextFormatter
            currencyText={currency}
            number={returnTransaction ?? 0}
          />
        ),
        sorter: (a, b) => a.returnTransaction - b.returnTransaction,
        sortDirections: ['descend', 'ascend']
      })
    }
    setColumns(columns)
  }

  useEffect(() => {
    if (dataSet) {
      parseData()
    }
  }, [dataSet])

  return columns.length > 0 ? (
    <Table
      showSorterTooltip={false}
      size='small'
      loading={loading}
      bordered={true}
      className={styles.statisticsTables}
      columns={columns}
      rowKey={element => element.category._id}
      onRow={element => {
        return {
          onClick: () => {
            history.push(
              `/dashboard-manager-products?manager=${managerId}&month=${date}&category=${element.category._id}`
            )
          }
        }
      }}
      rowClassName={styles.rowHoverPointer}
      pagination={{
        defaultPageSize: 9,
        total: data.items.length,
        position: ['bottomCenter']
      }}
      dataSource={data.items}
    />
  ) : ''
}
